import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { CommonService } from '../services';

@Injectable()
export class AdminAuthGuard implements CanActivate {
    baseUrl = '/account';
    result: any;
    userId: string;
    accountId: string;
    currentUserModel: CurrentUserModel;

    constructor(private _http: HttpClient,
        private router: Router,
        private authService: AuthService,
        private commonService: CommonService
        ) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.result = false;
        var routedata = next.data;
        this.result = this._http.get('api/values/GetLoggedInUserMenu')
            .pipe(map((res: any) => {
                //console.log(res);
                if (res) {
                    for (var j = 0; j < res.length; j++) {
                        if (res[j]['menuId'] == routedata.menuId) {
                            return true;
                        }
                    }
                }
                this.router.navigate(['/404']);
                return false;
            }));
        return this.result;
    }
}

@Injectable()
export class DDStaffAuthGuard implements CanActivate {
    result: any;
    userId: string;
    accountId: string;
    currentUserModel: CurrentUserModel;

    constructor(private _http: HttpClient,
        private router: Router,
        private authService: AuthService,
        private commonService: CommonService
        ) {
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.result = this.authService.getLoginInfo().pipe(map((res: CurrentUserModel) => {
                //console.log(res);
                if (res.isStaffAccount) {
                    return true;
                }
                this.router.navigate(['/404']);
                return false;
            }));
        return this.result;
    }
}


@Injectable()
export class DevOpsAuthGuard implements CanActivate {
    result: any

    constructor (private _http: HttpClient,
        private router: Router,
        private authService: AuthService,
        private commonService: CommonService)
    {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
        if (this.commonService.getIsDevOps()) {
            return true;
        }
        this.router.navigate(['/404']);
        return false;
    }
}
